import Vue from 'vue';
import Vuex from 'vuex';
import accounts from '@/store/modules/accounts';
import app from '@/store/modules/app';
import articles from '@/store/modules/articles';
import beliefStatements from '@/store/modules/belief_statements';
import channels from '@/store/modules/channels';
import episodeCollections from '@/store/modules/episode_collections';
import episodes from '@/store/modules/episodes';
import events from '@/store/modules/events';
import eventRegistrations from '@/store/modules/event_registrations';
import general from '@/store/modules/general';
import members from '@/store/modules/members';
import ministries from '@/store/modules/ministries';
import orders from '@/store/modules/orders';
import pages from '@/store/modules/pages';
import services from '@/store/modules/services';
import speakers from '@/store/modules/speakers';
import staffMembers from '@/store/modules/staff';
import waivers from '@/store/modules/waivers';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    accounts,
    app,
    articles: articles,
    belief_statements: beliefStatements,
    channels,
    episode_collections: episodeCollections,
    episodes,
    events,
    event_registrations: eventRegistrations,
    general,
    members,
    ministries,
    orders,
    pages,
    services,
    speakers,
    staff_members: staffMembers,
    waivers,
  },
  strict: debug,
});
